import React, {useEffect, useRef, useState} from "react";
import {Theme, Tooltip, useMediaQuery, withStyles} from "@material-ui/core";
import './index.scss';
import {Container} from "./Container";


const HtmlTooltip = withStyles((theme: Theme) => {
        return {
            tooltip: {
                backgroundColor: '#ffffff',
                color: '#9E9C9A',
                maxWidth: 500,
                fontSize: '16px',
                fontWeight: 'normal',
                padding: '25px',
                boxShadow: '0px 4px 24px rgba(0, 0, 0, 0.1)'
            },
            arrow: {
                color: '#ffffff'
            },
            '@media(minWidth: 780px)' : {
                maxWidth: 350,
            }
        }
    }
)(Tooltip) as any;

interface SimpleTooltip {
    title: React.ReactElement;
    placement?: "top" | "bottom" | "left" | "right";
    id?: string;
    leaveTouchDelay?: number;
}

const DEFAULT_LEAVE_TOUCH_DELAY = 3000;

export const SimpleTooltip: React.FC<SimpleTooltip> = ({leaveTouchDelay = DEFAULT_LEAVE_TOUCH_DELAY, placement, title, children, id}) => {
    const isMobile = useMediaQuery('(max-width: 1023px)');
    const [open, setOpen] = useState(false);
    const scrollListener = useRef(null);

    useEffect(() => {
        const handleScroll = () => {
            if (open) {
                setOpen(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        scrollListener.current = handleScroll;

        return () => {
            window.removeEventListener('scroll', scrollListener.current);
        };
    }, [open]);

    return (
        <HtmlTooltip title={(<>{title}</>)}
                     open={(isMobile && leaveTouchDelay !== DEFAULT_LEAVE_TOUCH_DELAY) ? open : undefined}
                     className={"simple-tooltip"}
                     enterTouchDelay={50}
                     leaveTouchDelay={isMobile ? leaveTouchDelay : undefined}
                     placement={placement || "bottom"}
                     arrow={true}
                     id={id}
                     key={id + isMobile}
                     interactive={true}
                     onClose={() => setOpen(false)}
        >
            <Container onClick={() => setOpen((prevOpen) => !prevOpen)}>
                {children}
            </Container>
        </HtmlTooltip>
    );
};